import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  loadCollections,
  createCollection,
  addToCollection,
  removeFromCollection,
  removeChessFromCollection,
  checkBuilding
} from 'actions/collections';
import { setPopUp } from 'actions/environment';
import { createSelector } from 'reselect';
import Checkbox from 'components/common/Checkbox';
import cn from 'classnames';
import styles from './CollectionsDialog.scss';
import iconCross from 'assets/images/icons/cross.svg';
import nothingFound from 'assets/images/nothingfound.png';

import ScrollLock from 'components/ScrollLock';
import { ROOT_URL } from '../../../../constants/Config';
import { withTranslation } from 'react-i18next';
import tracker from '../../../../services/tracker';

class Collections extends Component {

  constructor(props) {
    super(props);
    this.initialState = {
      buildingChecked: false,
      newCollection: false,
      collectionName: ''
    };
    this.state = this.initialState;
  }

  componentDidMount() {
    const { userUid, chessId } = this.props;
    this.props.loadCollections({ userUid })
      .then(() => {
        const data = {
          buildingId: this.props.building.data.id
        };

        if (chessId) {
          data.chessId = chessId;
        }

        return this.props.checkBuilding(data);
      })
      .then(
        () => this.setState({
          buildingChecked: true
        })
      );
  }

  componentWillUnmount() {
    this.props.dialogClosed();
  }

  handleBackClick = (e) => {
    this.setState({
      newCollection: false
    });
  }

  handleNewCollectionClick = (e) => {
    const { chessId, building } = this.props;

    if (chessId) {
      tracker.sendEvent('Web_Lots_AddToNewCollection', {
        id: building.data.id,
        title: building.data.title
      });
    }

    this.setState({
      newCollection: true
    });
  }

  handleChange = (e) => {
    this.setState({
      collectionName: e.target.value
    });
  }

  handleCreateClick = (e) => {
    e.preventDefault();
    this.props.createCollection({
      // userUid: this.props.userUid,
      name: this.state.collectionName
    });
    this.setState(this.initialState);
  }

  handleReadyClick = (e) => {
    this.props.setPopUp();
  }

  handleClick = ({ isChecked, referal, collectionName }) => {
    const { chessId, building } = this.props;
    const { userUid } = this.props;
    const { id: buildingId } = building.data;

    const meta = {
      collectionName,
      buildingName: building.data.title,
      data: building.data
    };

    const data = {
      referal,
      userUid,
      buildingId
    };

    if (chessId) {
      data.chessId = chessId;
    }

    if (!isChecked) {
      this.props.addToCollection(data, meta).then(() => this.props.loadCollections({ userUid }, true));
      return;
    }

    if (chessId) {
      this.props.removeChessFromCollection(data, meta).then(() => this.props.loadCollections({ userUid }, true));
      return;
    }

    this.props.removeFromCollection(data, meta).then(() => this.props.loadCollections({ userUid }, true));
  }

  render() {
    const { collections, building, t } = this.props;
    const { status } = building.data;

    let pavilions = building.data.pavilions;
    let statusClass;
    let deadline;

    if (pavilions) {
      let year,
        quarter;
      let check = 20994; // 2099 г. 4 кв.
      const finished = (pavilions || []).some((pavilion) => {
        const { construction_finished, year_built, construction_ending } = pavilion;
        const current = Number(`${year_built}${construction_ending}`);
        if (year_built && construction_ending && check > current) {
          check = current;
          year = year_built; quarter = construction_ending;
        }
        return construction_finished;
      });
      deadline = finished
          ? t('components.building.main.collectionDialog.finished') : ((year === 0) ? t('components.building.main.collectionDialog.inProgress')
          : ((year && quarter) ? `${quarter} / ${year}` : ''));
      statusClass = finished ? styles.Finished : styles.NotFinished;
    } else {
      const year_built = building.data.year_built;
      const construction_ending = building.data.construction_ending;
      const construction_finished = building.data.construction_finished;
      statusClass = construction_finished ? styles.Finished : styles.NotFinished;
      deadline = construction_finished ? t('components.building.main.collectionDialog.finishedBIG') : `${year_built !== 0 ? ((construction_ending ? `${construction_ending} / ` : '') + year_built) : t('components.building.main.collectionDialog.inProgress')}`;
    }

    return (
      <div>
        {collections ? (
            Object.keys(collections).length ?
              <div className={styles.PopupContent}>
                <div className={styles.PopupTitle}>{t('components.building.main.collectionDialog.add')}</div>
                <div className={styles.ObjectInfo}>
                  {building.data.image ?
                    <div className={styles.ObjectInfoImage}>
                      <img
                        src={`${ROOT_URL}/image?id=${building.data.image.id}&size=small`}
                        alt=""
                      />
                    </div>
                    : null}
                  <div className={styles.ObjectInfoText}>
                    <div className={styles.ObjectInfoTitle}>
                      {building.data.title}
                    </div>
                    <div className={styles.ObjectInfoAddress}>
                      {building.data.subregion ? building.data.subregion.name : building.data.microregion}, {building.data.address}
                    </div>
                  </div>
                  {status == 3 ?
                    <div className={cn(styles.ObjectInfoStatus, styles.AlmostFinished)}>
                      {t('components.building.main.collectionDialog.almostFinished')}
                    </div>
                    :
                    <div className={cn(styles.ObjectInfoStatus, statusClass)}>
                      {deadline}
                    </div>
                  }
                </div>
                <ScrollLock>
                  <div className={cn(styles.PopupCollections, { [styles.NewCollection]: this.state.newCollection }, 'custom-scrollbar')}>
                    {
                      this.state.buildingChecked || true ? Object.values(collections)
                      .sort((a, b) => +a.id < +b.id ? 1 : -1)
                      .map(({ id, referal, name, photos, includesCurrentBuilding, total = 0 }) =>
                        <div className={cn(styles.CheckItem)} key={id}>
                          <div className={styles.Checkbox}>
                            <Checkbox
                              classNameClone="CheckboxClonePrint"
                              text={<span>{name}</span>}
                              checked={includesCurrentBuilding}
                              handle={() => this.handleClick({
                                collectionName: name,
                                isChecked: includesCurrentBuilding,
                                referal
                              })}
                            />
                          </div>
                          <div className={styles.TotalObjects}>
                            {t('components.building.main.collectionDialog.total', { total })}
                          </div>
                        </div>
                    ) : <div className={styles.Loader} />
                  }
                  </div>
                </ScrollLock>
                <div className={styles.PopupActions}>
                  {
                  this.state.newCollection ?
                    <form className={styles.ActionCreateCollection} onSubmit={this.handleCreateClick}>
                      <div className={styles.ActionCreateCollectionTop}>
                        {t('components.building.main.collectionDialog.createNew')}
                        <span className={styles.ActionBack} onClick={this.handleBackClick}>
                          <img src={iconCross} alt="" />
                        </span>
                      </div>
                      <div className={styles.ActionCreateCollectionBottom}>
                        <input
                          type="text"
                          className={styles.CreateCollectionInput}
                          placeholder={t('components.building.main.collectionDialog.enterName')}
                          onChange={this.handleChange}
                        />
                        <button
                          className={cn(styles.ActionBtn, styles.CreateCollectionButton, 'button-primary', 'button-primary--md')}
                          disabled={!this.state.collectionName}
                        >
                          {t('components.building.main.collectionDialog.button')}
                        </button>
                      </div>
                    </form> :
                    <div>
                      <div className={styles.ActionCreateButton}>
                        <button onClick={this.handleNewCollectionClick}>
                          <span><i></i><i></i></span>
                          {t('components.building.main.collectionDialog.button')}
                        </button>
                      </div>
                      <div className={styles.ActionDone}>
                        <button className={cn(styles.ActionBtn, 'button-primary', 'button-primary--md')} onClick={this.handleReadyClick}>
                          {t('components.building.main.collectionDialog.done')}
                        </button>
                      </div>
                    </div>
                }
                </div>
              </div> :
              <div className={cn(styles.PopupContent, styles.NoCollections)}>
                <div className={styles.NoCollectionsContent}>
                  <img className={cn(styles.NoCollectionsImage)} src={nothingFound} alt="nothing found" />
                  <div className={styles.NoCollectionsTitle}>
                    {t('components.building.main.collectionDialog.empty')}
                  </div>
                  <div className={styles.NoCollectionsText}>
                    {t('components.building.main.collectionDialog.description')}
                  </div>
                </div>
                <div className={cn(styles.PopupActions, styles.NoCollections)}>
                  <form className={styles.ActionCreateCollection} onSubmit={this.handleCreateClick}>
                    <div className={styles.ActionCreateCollectionTop}>
                      {t('components.building.main.collectionDialog.createNew')}
                    </div>
                    <div className={styles.ActionCreateCollectionBottom}>
                      <input
                        type="text"
                        className={cn(styles.CreateCollectionInput)}
                        placeholder={t('components.building.main.collectionDialog.enterName')}
                        onChange={this.handleChange}
                      />
                      <button
                        className={cn(styles.ActionBtn, styles.CreateCollectionButton, 'button-primary', 'button-primary--md')}
                        disabled={!this.state.collectionName}
                      >
                        {t('components.building.main.collectionDialog.button')}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
          ) : <div className={styles.Loader} />
        }
      </div>
    );
  }
}

const collectionsDialogSelector = createSelector(
  state => state.profile,
  state => state.collections.data,
  (profile, collections) => ({
    userUid: profile.hash,
    collections
  })
);

export default withTranslation()(connect(
  collectionsDialogSelector,
  {
    loadCollections,
    createCollection,
    addToCollection,
    removeFromCollection,
    removeChessFromCollection,
    checkBuilding,
    setPopUp,
    dialogClosed: () => ({ type: 'CLOSE_COLLECTIONS_DIALOG' })
  }
)(Collections));



// WEBPACK FOOTER //
// ./src/components/Building/Main/CollectionsDialog/CollectionsDialog.js